import { Injectable } from '@angular/core';
import { SignalsStoreService } from '@core/services/signals-store.service';

export interface LoaderStore {
  loading: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LoaderStoreService extends SignalsStoreService<LoaderStore> {}
